import { asyncRoutes, constantRoutes } from '@/router';
import { loadMenu } from '@/libs/router-util';
function hasPermission(accesses, route) {
  if (route.meta && route.meta.access) {
    return accesses.some((access) => route.meta.access.includes(access));
  } else {
    return true;
  }
}

export function filterAsyncRoutes(routes, access) {
  const res = [];
  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(access, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, access);
      }
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  CLEAR_ROUTES: () => {
    state.addRoutes = [];
    state.routes = [];
  },
};

const actions = {
  generateRoutes({ commit }, access) {
    return new Promise(async (resolve) => {
      let menu = await loadMenu();
      let menuRouter = [...asyncRoutes, ...menu];
      const accessedRoutes = filterAsyncRoutes(menuRouter, access);
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
